import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modal-set-new-password",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "password-input-container mb-3" }
const _hoisted_6 = { class: "password-validation-wrapper" }
const _hoisted_7 = { class: "password-input-container mt-3" }
const _hoisted_8 = {
  class: "alert alert-info mt-4",
  role: "alert"
}
const _hoisted_9 = { class: "alert__icon" }
const _hoisted_10 = { class: "modal-footer py-3" }
const _hoisted_11 = ["disabled"]

import { Modal } from 'bootstrap'
  import InputComponent from '@/components/Atoms/Input.vue'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import PasswordValidation from '../components/Molecules/PasswordValidation.vue'

  import { ref, onMounted, computed, watch } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalSetNewPassword',
  emits: ['proceed'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const password = ref('')
  const passwordError = ref('')
  const repeatedPassword = ref('')
  const repeatedPasswordError = ref('')
  const repeatedPasswordIsBeingEdited = ref(false)
  const passwordIsValid = ref(false)

  const passwordsAreEqual = computed(
    () => password.value === repeatedPassword.value,
  )
  const canProceed = computed(
    () => passwordIsValid.value && passwordsAreEqual.value,
  )

  const emit = __emit

  watch(repeatedPassword, (current) => {
    if (current === '' || current === password.value) {
      repeatedPasswordError.value = ''
      passwordError.value = ''
      return
    }

    if (current !== password.value) {
      repeatedPasswordError.value = 'As senhas não correspondem.'
      passwordError.value = 'As senhas não correspondem.'
    }
  })

  watch(repeatedPasswordIsBeingEdited, (current) => {
    if (!current) {
      repeatedPasswordError.value = ''
      passwordError.value = ''
      return
    }

    if (repeatedPassword.value === '') {
      repeatedPasswordError.value = ''
      passwordError.value = ''
      return
    }

    if (repeatedPassword.value !== password.value) {
      repeatedPasswordError.value = 'As senhas não correspondem.'
      passwordError.value = 'As senhas não correspondem.'
    }
  })

  onMounted(() => {
    modal.value = new Modal('#modal-set-new-password', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function proceed() {
    emit('proceed', password.value)
    hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header pb-2" }, [
          _createElementVNode("h5", { class: "modal-title" }, "Senha de uso")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "fs-6 text-start" }, [
            _createTextVNode(" Sua senha deve ter entre "),
            _createElementVNode("strong", null, "8 e 12 caracteres"),
            _createTextVNode(", ter pelo menos uma letra "),
            _createElementVNode("strong", null, "maíuscula"),
            _createTextVNode(", uma letra "),
            _createElementVNode("strong", null, "minúscula"),
            _createTextVNode(" e "),
            _createElementVNode("strong", null, "números"),
            _createTextVNode(". ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-start align-items-center pb-2" }, [
              _createElementVNode("span", { class: "fs-6 pe-2" }, "Senha de uso *")
            ], -1)),
            _createVNode(InputComponent, {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
              icon: "lock",
              type: "password",
              placeholder: "Digite sua senha aqui",
              "error-log": passwordError.value
            }, null, 8, ["modelValue", "error-log"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(PasswordValidation, {
              modelValue: passwordIsValid.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordIsValid).value = $event)),
              password: password.value
            }, null, 8, ["modelValue", "password"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex justify-content-start align-items-center pb-2" }, [
              _createElementVNode("span", { class: "fs-6 pe-2" }, "Repetir senha de uso *")
            ], -1)),
            _createVNode(InputComponent, {
              modelValue: repeatedPassword.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatedPassword).value = $event)),
              icon: "lock",
              type: "password",
              placeholder: "Digite sua senha aqui",
              "error-log": repeatedPasswordError.value,
              onFocused: _cache[3] || (_cache[3] = ($event: any) => (repeatedPasswordIsBeingEdited.value = true)),
              onBlured: _cache[4] || (_cache[4] = ($event: any) => (repeatedPasswordIsBeingEdited.value = false))
            }, null, 8, ["modelValue", "error-log"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(IconComponent, { name: "bell" })
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "alert__content text-start" }, [
                _createElementVNode("span", { class: "text" }, [
                  _createElementVNode("strong", null, "A senha de uso será solicitada"),
                  _createTextVNode(" sempre que você utilizar o seu Certificado Digital. ")
                ])
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn", [canProceed.value ? 'btn-primary' : 'btn-secondary']]),
            disabled: !canProceed.value,
            onClick: proceed
          }, [
            _cache[9] || (_cache[9] = _createTextVNode(" Cadastrar e avançar ")),
            _createVNode(IconComponent, {
              name: "arrow-right",
              class: "ms-2"
            })
          ], 10, _hoisted_11)
        ])
      ])
    ])
  ]))
}
}

})